/* Keep wholesale cart free-shipping progress bar filled from live cart totals. */
(function () {
  var THRESHOLD = 75000;

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || window.moneyFormat || '${{amount}}');
      }
    } catch (e) {}
    var n = (Math.max(0, cents) / 100).toFixed(2);
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function apply(note, total) {
    if (!note) return;
    var threshold = parseInt(note.getAttribute('data-fll-freeship-threshold'), 10) || THRESHOLD;
    total = Math.max(0, parseInt(total, 10) || 0);
    var remain = threshold - total;
    var pct = threshold > 0 ? Math.round((total * 100) / threshold) : 0;
    if (pct > 100) pct = 100;
    if (pct < 0) pct = 0;
    var fillPct = total > 0 && pct < 3 && remain > 0 ? 3 : pct;
    note.setAttribute('data-fll-freeship-total', String(total));
    note.setAttribute('data-fll-freeship-pct', String(fillPct));
    note.classList.toggle('fll-freeship-note--met', remain <= 0);
    var track = note.querySelector('.fll-freeship-note__track');
    var fill = note.querySelector('.fll-freeship-note__fill');
    if (track) track.style.setProperty('--fll-ship-pct', fillPct + '%');
    if (fill) fill.style.width = fillPct + '%';
    var text = note.querySelector('[data-fll-freeship-text]');
    if (text) {
      if (remain > 0) {
        text.innerHTML = 'You&rsquo;re <strong data-fll-freeship-remain>' + money(remain) + '</strong> away from free shipping';
      } else {
        text.innerHTML = 'You&rsquo;ve unlocked <strong>free shipping</strong>';
      }
    }
  }

  function syncFromCart(cart) {
    var notes = document.querySelectorAll('[data-fll-freeship]');
    if (!notes.length) return;
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : null;
    if (total == null) {
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-fll-freeship]').forEach(function (note) {
            apply(note, c.total_price);
          });
        })
        .catch(function () {});
      return;
    }
    notes.forEach(function (note) { apply(note, total); });
  }

  function boot() {
    document.querySelectorAll('[data-fll-freeship]').forEach(function (note) {
      apply(note, note.getAttribute('data-fll-freeship-total'));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('fll:cart-changed', function (event) {
    syncFromCart(event && event.detail);
  });
  document.addEventListener('cart:updated', function (event) {
    syncFromCart(event && event.detail);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        syncFromCart(event && (event.cartData || event.cart));
      });
    } catch (e) {}
  }
})();
